<template>
  <v-slide-y-transition group tag="div" class="loan-container">
    <div v-if="ready && item" key="content" class="content">
      <h3>
        대출 신청이 완료되었습니다.<br />
        {{ item.name }} 담당자가 연락드릴 예정입니다.
      </h3>

      <v-card class="mt-8 elevation-0 rounded-4" color="#E5F6FF">
        <v-card-text class="primary--text">
          <v-layout justify-space-between>
            <span class="font-weight-bold">예상 대출 금리</span>
            <span class="font-weight-black">
              연

              <template v-if="item.minInterestRate !== item.maxInterestRate">
                {{ trimDecimalZeros(toPercentage(item.minInterestRate, 2)) }} ~
              </template>

              {{ trimDecimalZeros(toPercentage(item.maxInterestRate, 2)) }}%
            </span>
          </v-layout>

          <v-layout justify-space-between>
            <span class="font-weight-bold">예상 대출 한도</span>
            <span class="font-weight-black">
              <template v-if="item.minLoanAmount !== item.maxLoanAmount">
                {{ commaFormat(parseInt(item.minLoanAmount / 10000)) }} ~
              </template>

              {{ commaFormat(parseInt(item.maxLoanAmount / 10000)) }} 만원
            </span>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </v-slide-y-transition>
</template>

<script>
import { commaFormat } from '@/filter/number'
import { toPercentage, trimDecimalZeros } from '@/util/mathUtil'

import { mapActions } from 'vuex'

export default {
  data() {
    return {
      ready: false,
      item: null,
    }
  },

  async created() {
    this.item = await this.getLoanOfferByUuid(this.$route.params.uuid)
  },

  mounted() {
    this.ready = true
  },

  methods: {
    toPercentage,
    commaFormat,
    trimDecimalZeros,
    ...mapActions('loanMarketplace', ['getLoanOfferByUuid']),
  },
}
</script>

<style lang="scss" scoped>
.v-list-item {
  padding-left: 0px !important;
  padding-right: 0px !important;

  &::after {
    display: none;
  }
}
</style>
